import React from 'react';
import styled from 'styled-components';

import { Box, Flex, Text } from '../UIKit/system';
import Link from '../link';
import LazyImage from '../lazy-image';

const Image = styled(LazyImage)`
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.image});
  background-size: cover;
  transition: 1000ms;
  background: transparent;
  border-radius: var(--Radius-Radius-3, 16px);

  /*filter: brightness(60%);*/
`;

const StyledShortcutLink = styled(Link)`
  display: block;
  margin-right: 20px;
  background-size: cover;
  text-align: left;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  position: relative;
  border-radius: var(--Radius-Radius-3, 16px);
  background: transparent;
  &:last-child {
    margin-right: 0;
  }

  &:hover {
    ${Image} {
      transform: scale(1.1);
    }
  }
`;

const GradientOverlay = styled.div`
  background: radial-gradient(circle at 80% 0%, transparent 0%, #08090a 100%);
  opacity: 0.7;
  position: absolute;
  border-radius: var(--Radius-Radius-3, 16px);
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
  display: block;
`;

const Title = styled(Text)`
  font-weight: 500;
  font-size: 14px;
  display: block;
  z-index: 3;
  position: relative;
`;

const Subtitle = styled(Text)`
  display: block;
  z-index: 3;
  position: relative;
  font-size: 13px;
`;

function ShortcutLink({ title, subtitle, image, ...rest }) {
  return (
    <StyledShortcutLink color={'#fff'} {...rest}>
      <Flex
        position={'relative'}
        p={14}
        alignItems={'flex-end'}
        width={210}
        height={150}
        backgroundSize={'cover'}
      >
        <GradientOverlay />
        <Image fluid={image} />
        <Box position={'relative'} zIndex={3}>
          <Subtitle fontSizeSmall>{subtitle}</Subtitle>
          <Title>{title}</Title>
        </Box>
      </Flex>
    </StyledShortcutLink>
  );
}

export default ShortcutLink;
